import PubSub from './utils/pub-sub';

const emitter = new PubSub();

export default emitter;
